import { TraceCategory } from '@sternum/web/features/monitoring/models';

export const getDisplayNameByTraceCategory = {
  [TraceCategory['AuthenticationEvent']]: 'Authentication Event',
  [TraceCategory['CommunicationEvent']]: 'Communication Event',
  [TraceCategory['CriticalEvent']]: 'Critical Event',
  [TraceCategory['CryptoEvent']]: 'Crypto Event',
  [TraceCategory['DiagnosticsEvent']]: 'Diagnostics Event',
  [TraceCategory['FileEvent']]: 'File Event',
  [TraceCategory['OsEvent']]: 'OS Event',
  [TraceCategory['SecurityEvent']]: 'Security Event',
  [TraceCategory['UpdateEvent']]: 'Update Event',
  [TraceCategory['RegulationAndQualityEvent']]: 'Regulation & Quality',
  [TraceCategory['OperationsEvent']]: 'Operations',
  [TraceCategory['UserActivityEvent']]: 'User Activity',
};
